export function createGushParcelPopupTemplate(layerTitle: string, language: 'he' | 'en', isInternalUser: boolean = false) {
    const fieldLabels = {
        he: {
            gush_num: 'מספר גוש',
            tat_gush: 'תת גוש',
            parcel: 'חלקה',
            legal_area: 'שטח (מ"ר)'
        },
        en: {
            gush_num: 'Block Number',
            tat_gush: 'Sub-Block',
            parcel: 'Parcel',
            legal_area: 'Area (sqm)'
        }
    };

    const disclaimers = {
        he: 'שימוש בשכבה מובא לעזר בלבד ואינו מהווה אסמכתה. יש לוודא מול בעל המידע האחראי על העניין.',
        en: 'Data is for reference only and not an authoritative source. Verify with the data owner.'
    };

    const labels = fieldLabels[language];
    const disclaimer = disclaimers[language];
    const fieldNames = ['gush_num', 'tat_gush', 'parcel', 'legal_area'];

    const popupTemplate = {
        title: layerTitle,
        content: (feature: any) => {
            const attributes = feature.graphic.attributes;
            let contentHTML = `<table class="esri-widget__table">`;
            let colorIndex = true;

            fieldNames.forEach(fieldName => {
                const value = attributes[fieldName];
                const label = labels[fieldName as keyof typeof labels];
                
                if (value != null) {
                    if (colorIndex) {
                        contentHTML += `<tr><td><div style="text-align:center;">${label}</div></td><td class="esri-feature-fields__field-data"><div style="text-align:center;">${value}</div></td></tr>`;
                        colorIndex = false;
                    } else {
                        contentHTML += `<tr><td class="esri-feature-fields__field-data"><div style="text-align:center;">${label}</div></td><td><div style="text-align:center;">${value}</div></td></tr>`;
                        colorIndex = true;
                    }
                }
            });

            contentHTML += "</table>";
            
            // Only show disclaimer for external users
            if (!isInternalUser) {
                contentHTML += `<div style="margin-top: 10px; padding: 8px; background-color: #fff3cd; border: 1px solid #ffc107; border-radius: 4px; font-size: 0.9em; color: #856404;">${disclaimer}</div>`;
            }
            
            return contentHTML;
        },
    };
    
    return popupTemplate;
}
